import SideMenuLayout from "./SideMenuLayout";

export default SideMenuLayout;
